module.exports = __webpack_public_path__ + "static/img/28.50f558cb.png";